import { render, staticRenderFns } from "./puppy-for-sale-page.vue?vue&type=template&id=20eec47e&scoped=true&lang=pug"
import script from "./puppy-for-sale-page.js?vue&type=script&lang=js&external"
export * from "./puppy-for-sale-page.js?vue&type=script&lang=js&external"
import style0 from "./puppy-for-sale-page.vue?vue&type=style&index=0&id=20eec47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eec47e",
  null
  
)

export default component.exports